// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import '@microsoft/applicationinsights-shims';
export { Util, CorrelationIdHelper, UrlHelper, DateTimeUtils } from './Util';
export { ConnectionStringParser } from './ConnectionStringParser';
export { FieldType } from './Enums';
export { RequestHeaders } from './RequestResponseHeaders';
export { DisabledPropertyName, ProcessLegacy, SampleRate, HttpMethod, DEFAULT_BREEZE_ENDPOINT } from './Constants';
export { Data as AIData } from './Interfaces/Contracts/Generated/Data';
export { Base as AIBase } from './Interfaces/Contracts/Generated/Base';
export { ISerializable } from './Interfaces/Telemetry/ISerializable';
export { IEnvelope } from './Interfaces/Telemetry/IEnvelope';
export { Envelope } from './Telemetry/Common/Envelope';
export { Event } from './Telemetry/Event';
export { Exception } from './Telemetry/Exception';
export { Metric } from './Telemetry/Metric';
export { PageView } from './Telemetry/PageView';
export { PageViewData } from './Interfaces/Contracts/Generated/PageViewData';
export { RemoteDependencyData } from './Telemetry/RemoteDependencyData';
export { IEventTelemetry } from './Interfaces/IEventTelemetry';
export { ITraceTelemetry } from './Interfaces/ITraceTelemetry';
export { IMetricTelemetry } from './Interfaces/IMetricTelemetry';
export { IDependencyTelemetry } from './Interfaces/IDependencyTelemetry';
export { IExceptionTelemetry, IAutoExceptionTelemetry, IExceptionInternal } from './Interfaces/IExceptionTelemetry';
export { IPageViewTelemetry, IPageViewTelemetryInternal } from './Interfaces/IPageViewTelemetry';
export { IPageViewPerformanceTelemetry, IPageViewPerformanceTelemetryInternal } from './Interfaces/IPageViewPerformanceTelemetry';
export { Trace } from './Telemetry/Trace';
export { PageViewPerformance } from './Telemetry/PageViewPerformance';
export { Data } from './Telemetry/Common/Data';
export { SeverityLevel } from './Interfaces/Contracts/Generated/SeverityLevel';
export { IConfig, ConfigurationManager } from './Interfaces/IConfig';
export { IChannelControlsAI } from './Interfaces/IChannelControlsAI';
export { ContextTagKeys } from './Interfaces/Contracts/Generated/ContextTagKeys';
export { DataSanitizer } from './Telemetry/Common/DataSanitizer';
export { TelemetryItemCreator } from './TelemetryItemCreator';
export { ICorrelationConfig } from './Interfaces/ICorrelationConfig';
export { IAppInsights } from './Interfaces/IAppInsights';
export { IWeb } from './Interfaces/Context/IWeb';
export { CtxTagKeys, Extensions } from './Interfaces/PartAExtensions';
export { ISession } from './Interfaces/Context/ISession';
export { ITelemetryContext } from './Interfaces/ITelemetryContext';
export { IApplication } from './Interfaces/Context/IApplication';
export { IDevice } from './Interfaces/Context/IDevice';
export { IInternal } from './Interfaces/Context/IInternal';
export { ILocation } from './Interfaces/Context/ILocation';
export { ISample } from './Interfaces/Context/ISample';
export { IOperatingSystem } from './Interfaces/Context/IOperatingSystem';
export { IPropertiesPlugin } from './Interfaces/IPropertiesPlugin';
export { IUser, IUserContext } from './Interfaces/Context/IUser';
export { ITelemetryTrace, ITraceState } from './Interfaces/Context/ITelemetryTrace';
export { DistributedTracingModes } from './Enums';
export const PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
export const BreezeChannelIdentifier = "AppInsightsChannelPlugin";
export const AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
